import { css } from '@emotion/react';

export const card2FAStyle = css`
  width: 40%;
  max-width: 700px;
  padding: 64px;
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  & > img {
    margin-top: 16px;
  }

  @media (max-width: 1900px) {
    width: 45%;
    padding: 48px;
  }

  @media (max-width: 1440px) {
    width: 55%;
    padding: 48px;
  }

  @media (max-width: 1024px) {
    width: 80%;
    padding: 48px;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: 100vh;
    padding: 32px;
  }
`;
